// extracted by mini-css-extract-plugin
module.exports = {"container":"_c2","item":"_c3","itemSingle":"_c4","itemContainer":"_c5","icon":"_c6","title":"_c7","text":"_c8","link":"_c9"};